import { MenuItem, RouteCodeEnum } from '@models/menu';
import { ContextInfo } from '@system/context';

import { UserWithLastContractContext } from '../models';

export function preserveLastContractContext(
  userData: UserWithLastContractContext,
  previousLastContractContext?: ContextInfo,
): UserWithLastContractContext {
  return {
    ...userData,
    lastContractContext: userData.context?.contract
      ? userData.context
      : (userData.lastContractContext ?? previousLastContractContext),
  };
}

export function getContextEntityInstanceId(context?: ContextInfo): number | undefined {
  return (
    context?.contract?.entityInstanceId ?? context?.project?.entityInstanceId ?? context?.program?.entityInstanceId
  );
}

export function shouldKeepHierarchyContext(menuItem: MenuItem, context?: ContextInfo): boolean {
  return (
    menuItem.code === RouteCodeEnum.Dashboard ||
    (menuItem.code === RouteCodeEnum.FileContractManager && !!getContextEntityInstanceId(context))
  );
}
